/************************************************************************
* Ajax extension for datatables                                         *
*************************************************************************/
(function ($) {

    if (!$.fn.dataTableExt) {
        return;
    }

    function DoAjax(listAction, requestData, callbackFunction, settings) {
        let ajaxPromise;

        if (listAction.ajaxPromise) {
            ajaxPromise = listAction.ajaxPromise;
        } else if (listAction.ajaxFunction) {
            let inputFilter = {};

            // set table defined filters
            if (listAction.inputFilter) {
                inputFilter = $.extend(inputFilter, listAction.inputFilter());
            }

            // set paging filters
            if (settings.oInit.paging) {
                inputFilter = $.extend(inputFilter, {
                    maxResultCount: requestData.length,
                    skipCount: requestData.start
                });
            }

            // set sorting filter
            if (requestData.order && requestData.order.length > 0) {
                if (!inputFilter.sorting) {
                    inputFilter.sorting = "";
                }

                for (let i = 0; i < requestData.order.length; i++) {
                    const orderingField = requestData.order[i];
                    if (i > 0) {
                        inputFilter.sorting += ",";
                    }
                    if (requestData.columns[orderingField.column].name) {
                        inputFilter.sorting += requestData.columns[orderingField.column].name + " " + orderingField.dir;
                    }
                    else if (requestData.columns[orderingField.column].data) {
                        inputFilter.sorting += requestData.columns[orderingField.column].data + " " + orderingField.dir;
                    }
                }
            }

            // execute ajax function with filter
            ajaxPromise = listAction.ajaxFunction(inputFilter);
        }

        if (ajaxPromise) {
            ajaxPromise.done(function (result) {
                // store raw server response for custom rendering.
                settings.rawServerResponse = result;

                // html encoding can be disabled by adding "disableResponseHtmlEncoding: true" to "listAction" field
                var dataItems;
                if (listAction.disableResponseHtmlEncoding) {
                    dataItems = result.items;
                } else {
                    // HTML encodes the response items for XSS protection.
                    dataItems = app.utils.html.htmlEncodeJson(result.items);
                }

                // before updating the UI, hide all the tooltip(s) shown by elements within the datatable,
                // otherwise the tooltips might be "stuck".
                $('[aria-describedby^="tooltip"]', settings.nTableWrapper).tooltip("hide");

                // invoke callback
                callbackFunction({
                    recordsTotal: result.totalCount,
                    recordsFiltered: result.totalCount,
                    data: dataItems
                });

                if (result.retrievedDateTime) {
                    $(".dt-retrieved-datetime", settings.nTableWrapper)
                        .show()
                        .html(app.localize("RetrievedOn", `<span class="text-success font-weight-bolder">${abp.dateTimeFormatter.formatShortDate(result.retrievedDateTime)} ${abp.dateTimeFormatter.formatLongTime(result.retrievedDateTime)}</span>`));
                } else {
                    $(".dt-retrieved-datetime", settings.nTableWrapper).hide();
                }
            }).always(function () {
                abp.ui.clearBusy($(settings.nTable).closest(".middle"));

                const api = new $.fn.dataTable.Api(settings);
                if (api.fixedHeader && api.fixedHeader.enabled()) {
                    api.fixedHeader.adjust();
                }
            });
        }
    }

    if (!$.fn.dataTable) {
        return;
    }

    $.extend(true, $.fn.dataTable.defaults, {
        ajax: function (requestData, callbackFunction, settings) {
            if (!settings?.oInit?.listAction) {
                callbackFunction({ data: [] });
                return;
            }

            const api = new $.fn.dataTable.Api(settings);

            if (settings.oInit.listAction.noAjax) {
                // When a DataTable is redrawn, it'll make an AJAX request to the server.
                // Sometimes this is not desirable as we would just like the DataTable to be redrawn with the current data held by the DataTable.
                // Here by assigning `true` to listAction.noAjax, the AJAX request made by DataTable will be intercepted and the current data is returned instead of making
                // an actual AJAX request to the server. listAction.noAjax is then removed so that the next time this is called, an actual AJAX request will then be made.
                callbackFunction({
                    recordsTotal: api.page.info().recordsTotal,
                    recordsFiltered: api.page.info().recordsDisplay,
                    data: api.rows().data()
                });

                delete settings.oInit.listAction.noAjax;

                return;
            }
            
            const $wrapper = $(api.table().container());
            if (!$wrapper.data("ajax-disable-busy")) {
                abp.ui.setBusy($(settings.nTable).closest(".middle"));
            } else {
                $wrapper.removeData("ajax-disable-busy");
            }

            DoAjax(settings.oInit.listAction, requestData, callbackFunction, settings);
        }
    });
    /*
    $.fn.dataTable.Api.register("ajax.reloadPage()", function () {
        // user paging is not reset on reload. https://datatables.net/reference/api/ajax.reload()
        this.ajax.reload(null, false);
    });
    */
})(jQuery);
